'use client'

import { createContext, useContext } from 'react'

import { type PublicFeatureToggles } from './featureToggles'

export const FeatureToggleContext = createContext<PublicFeatureToggles>({})

export const useFeatureToggle = (
  featureToggle: keyof PublicFeatureToggles,
): boolean => {
  const context = useContext(FeatureToggleContext)

  return Boolean(context[featureToggle])
}
